import { Link, useParams } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import "../commercial/ajouterCommercial.css"; // Using the same CSS as Commercial!
import { MagasinContext } from "../../../Context/MagasinContext";
import { FormEvent, useContext, useEffect, useState } from "react";
import { ClientInfo } from "../../../Modeles/Client";
import GetClientlById from "../../../Services/Admin/GetClientById";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import axios from "axios";

export interface ClientType {
  client: ClientInfo[];
  messageErrosclient: string;
}

export default function ModifierClient() {
  const params = useParams();
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");

  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const magIndex = pathParts.indexOf("magasins");
  const urlMagId = magIndex !== -1 && pathParts[magIndex + 1] ? pathParts[magIndex + 1] : null;
  const clientIndex = pathParts.indexOf("clients");
  const urlClientId = clientIndex !== -1 && pathParts[clientIndex + 1] ? pathParts[clientIndex + 1] : null;

  const idm = urlMagId || MagasinId || magasinContext.id?.id;
  const id = urlClientId || params.idClient || params.id;

  const [Nom, setNom] = useState<string>("");
  const [Prenom, setPrenom] = useState<string>("");
  const [Tele, setTele] = useState<string>("");
  const [Ville, setVille] = useState<string>("");
  const [ICE, setICE] = useState<string>("");
  const [Credit, setCredit] = useState<string>("");
  const [Remise, setRemise] = useState<string>("");
  const [Email, setEmail] = useState<string>("");
  const [Password, setPassword] = useState<string>("");
  const [Message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [stateCommercial, setstateCommercial] = useState<ClientType>({
    client: [] as ClientInfo[],
    messageErrosclient: "Aucun client",
  });

  useEffect(() => {
    setLoading(true);
    GetClientlById(id, idm)
      .GetClient()
      .then((res) => {
        const clientData = Array.isArray(res.data) ? res.data[0] : res.data;
        if (clientData) {
          setNom(clientData.NomClient || clientData.Nom || "");
          setPrenom(clientData.PrenomClient || clientData.Prenom || "");
          setTele(clientData.NumTele || clientData.Tele || "");
          setVille(clientData.Adresse || clientData.Ville || "");
          setICE(clientData.ICE || "");
          setCredit(clientData.Credit ?? "");
          setRemise(clientData.RemiseGlobale ?? clientData.Remise ?? "");
          setEmail(clientData.EmailClient || clientData.Email || "");
        }
        setstateCommercial({ ...stateCommercial, client: Array.isArray(res.data) ? res.data : (res.data ? [res.data] : []) });
        setLoading(false);
      })
      .catch((msg) => {
        setstateCommercial({
          ...stateCommercial,
          messageErrosclient: msg?.messageErrosclient || "Erreur de chargement",
        });
        setLoading(false);
      });
  }, [id, idm]);

  const { client, messageErrosclient } = stateCommercial;

  const handleSubmitUpdate = async (e: FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("_method", "post");
      formData.append("Nom", Nom);
      formData.append("Prenom", Prenom);
      formData.append("Tele", Tele);
      formData.append("Ville", Ville);
      formData.append("ICE", ICE);
      formData.append("Credit", Credit);
      formData.append("Remise", Remise);
      formData.append("Email", Email);
      formData.append("Password", Password);

      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${idm}/clients/${id}/edit`,
        formData
      );

      setMessage("Client modifié avec succès");
      setTimeout(() => {
        setMessage("");
      }, 2000);
    } catch (err) {
      console.error("Error updating client:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoBack = () => window.history.back();

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <NewSideBarMagasins />

        {loading ? (
          <div className="loader-wrapper-acmu">
            <div className="custom-spinner-acmu" role="status" />
            <span className="loader-charg-acmu">Chargement...</span>
          </div>
        ) : (
          <div className="page-wrapper-acmu">
            {client && client.length > 0 ? (
              client.map((com) => (
                <form key={com.id} onSubmit={handleSubmitUpdate}>
                  {/* Back + title */}
                  <div className="bar-retour-acmu">
                    <Link to="" onClick={handleGoBack} className="icon-retour-acmu">
                      <i className="bi bi-arrow-left-short" />
                    </Link>
                    <div className="marque-acmu" style={{ marginBottom: 0 }}>
                      <h4>
                        {com.NomClient} {com.PrenomClient}
                      </h4>
                    </div>
                  </div>

                  {/* Alert */}
                  {Message !== "" && (
                    <div className="alert-success-acmu">
                      <i className="bi bi-check2-circle" /> {Message}
                    </div>
                  )}

                  {/* Form */}
                  <div className="form-card-acmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Nom</label>
                      <input
                        type="text"
                        defaultValue={com.NomClient}
                        onChange={(e) => setNom(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Prénom</label>
                      <input
                        type="text"
                        defaultValue={com.PrenomClient || "N/A"}
                        onChange={(e) => setPrenom(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Téléphone</label>
                      <input
                        type="text"
                        defaultValue={com.Tele || "N/A"}
                        onChange={(e) => setTele(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Solde (MAD)</label>
                      <input
                        type="number"
                        defaultValue={com.credit}
                        onChange={(e) => setCredit(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Ville</label>
                      <input
                        type="text"
                        defaultValue={com.Adresse}
                        onChange={(e) => setVille(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">ICE</label>
                      <input
                        type="text"
                        defaultValue={com.ICE || "N/A"}
                        onChange={(e) => setICE(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Remise (%)</label>
                      <input
                        type="text"
                        defaultValue={com.RemiseGlobal || "0"}
                        onChange={(e) => setRemise(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Email</label>
                      <input
                        type="email"
                        defaultValue={com.Email || ""}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control-acmu"
                        placeholder="email@exemple.com"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Mot de passe</label>
                      <input
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control-acmu"
                        placeholder="Laisser vide pour ne pas changer"
                      />
                    </div>
                  </div>
                  <div className="btn-submit-wrap-acmu">
                    <button className="btn-submit-mobile-acmu" type="submit" disabled={submitting}>
                      {submitting ? "Modification en cours..." : "Modifier"}
                    </button>
                  </div>
                </form>
              ))
            ) : (
              <p>{messageErrosclient}</p>
            )}
          </div>
        )}
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <>
      <NewSideBarMagasins />
      {loading ? (
        <div className="loader-wrapper-acmu">
          <div className="custom-spinner-acmu" role="status" />
          <span className="loader-charg-acmu">Chargement...</span>
        </div>
      ) : (
        <div className="page-wrapper-acmu">
          {client && client.length > 0 ? (
            client.map((com) => (
              <form key={com.id} onSubmit={handleSubmitUpdate}>
                {/* Back + title */}
                <div className="bar-retour-acmu">
                  <Link to="" onClick={handleGoBack} className="icon-retour-acmu">
                    <i className="bi bi-arrow-left-short" />
                  </Link>
                  <div className="marque-acmu" style={{ marginBottom: 0 }}>
                    <h4>
                      {com.NomClient} {com.PrenomClient}
                    </h4>
                  </div>
                </div>

                {/* Alert */}
                {Message !== "" && (
                  <div className="alert-success-acmu">
                    <i className="bi bi-check2-circle" /> {Message}
                  </div>
                )}

                {/* Form */}
                <div className="form-card-acmu">
                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Nom</label>
                      <input
                        type="text"
                        defaultValue={com.NomClient}
                        onChange={(e) => setNom(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Prénom</label>
                      <input
                        type="text"
                        defaultValue={com.PrenomClient || "N/A"}
                        onChange={(e) => setPrenom(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Téléphone</label>
                      <input
                        type="text"
                        defaultValue={com.Tele || "N/A"}
                        onChange={(e) => setTele(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Solde (MAD)</label>
                      <input
                        type="number"
                        defaultValue={com.credit}
                        onChange={(e) => setCredit(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Ville</label>
                      <input
                        type="text"
                        defaultValue={com.Adresse}
                        onChange={(e) => setVille(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">ICE</label>
                      <input
                        type="text"
                        defaultValue={com.ICE || "N/A"}
                        onChange={(e) => setICE(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Remise (%)</label>
                      <input
                        type="text"
                        defaultValue={com.RemiseGlobal || "0"}
                        onChange={(e) => setRemise(e.target.value)}
                        className="form-control-acmu"
                      />
                    </div>
                    <div className="form-group-acmu">
                      {/* Empty column for layout balance */}
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Email</label>
                      <input
                        type="email"
                        defaultValue={com.Email || ""}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control-acmu"
                        placeholder="email@exemple.com"
                      />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Mot de passe</label>
                      <input
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control-acmu"
                        placeholder="Laisser vide pour ne pas changer"
                      />
                    </div>
                  </div>

                  <div className="btn-submit-wrap-acmu">
                    <button className="btn-submit-acmu" type="submit" disabled={submitting} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, opacity: submitting ? 0.75 : 1 }}>
                      {submitting ? (
                        <>
                          <span style={{ width: 16, height: 16, display: 'inline-block', border: '2.5px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spinC 0.65s linear infinite' }}></span>
                          Modification en cours...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-pencil-square" /> Modifier
                        </>
                      )}
                    </button>
                    <style>{`@keyframes spinC { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                  </div>
                </div>
              </form>
            ))
          ) : (
            <p
              style={{
                textAlign: "center",
                marginTop: 60,
                color: "var(--text-secondary-acmu)",
              }}
            >
              {messageErrosclient}
            </p>
          )}
        </div>
      )}
    </>
  );
}